import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, Directive, HostListener, HostBinding, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class DropdownComponent {
    constructor() {
        this.isOpen = false;
        this.customCssProps = {};
        this.canClose = true;
        this.align = undefined;
        this.toggleSubmenu = false;
        this.isClose = new EventEmitter();
    }
    toggle() {
        this.isOpen ? this.close() : this.open();
    }
    open() {
        this.isOpen = true;
        this.isClose.emit(false);
    }
    close() {
        if (this.canClose) {
            this.isOpen = false;
            this.isClose.emit(true);
        }
        else {
            this.isClose.emit(false);
        }
    }
    dropdownClass() {
        return { [`drop${this.align}`]: this.toggleSubmenu };
    }
}
DropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: DropdownComponent, selector: "ps-ui-dropdown", inputs: { customCssProps: "customCssProps", canClose: "canClose", align: "align", toggleSubmenu: "toggleSubmenu" }, outputs: { isClose: "isClose" }, exportAs: ["psUiDropdown"], ngImport: i0, template: "<div class=\"dropdown\">\n  <div\n    [ngClass]=\"dropdownClass()\"\n    [class.dropdown-menu]=\"!toggleSubmenu\"\n    [class.show]=\"isOpen\"\n    (click)=\"close()\"\n    [style]=\"customCssProps\"\n  >\n    <ng-content></ng-content>\n  </div>\n</div>\n\n<!-- Full screen overlay to catch clicks outside of the dropdown -->\n<div class=\"overlay\" (click)=\"close()\" *ngIf=\"isOpen\"></div>\n", styles: [".overlay{position:fixed;z-index:100;top:0;left:0;height:100%;width:100%;opacity:0}\n"], directives: [{ type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ps-ui-dropdown', exportAs: 'psUiDropdown', template: "<div class=\"dropdown\">\n  <div\n    [ngClass]=\"dropdownClass()\"\n    [class.dropdown-menu]=\"!toggleSubmenu\"\n    [class.show]=\"isOpen\"\n    (click)=\"close()\"\n    [style]=\"customCssProps\"\n  >\n    <ng-content></ng-content>\n  </div>\n</div>\n\n<!-- Full screen overlay to catch clicks outside of the dropdown -->\n<div class=\"overlay\" (click)=\"close()\" *ngIf=\"isOpen\"></div>\n", styles: [".overlay{position:fixed;z-index:100;top:0;left:0;height:100%;width:100%;opacity:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { customCssProps: [{
                type: Input
            }], canClose: [{
                type: Input
            }], align: [{
                type: Input
            }], toggleSubmenu: [{
                type: Input
            }], isClose: [{
                type: Output
            }] } });

class DropdownToggleDirective {
    constructor() { }
    toggleDropdown() {
        var _a;
        (_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.toggle();
    }
}
DropdownToggleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownToggleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
DropdownToggleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: DropdownToggleDirective, selector: "[psUiDropdownToggleFor]", inputs: { dropdown: ["psUiDropdownToggleFor", "dropdown"] }, host: { listeners: { "click": "toggleDropdown()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownToggleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[psUiDropdownToggleFor]',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { dropdown: [{
                type: Input,
                args: ['psUiDropdownToggleFor']
            }], toggleDropdown: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * A directive that applies dropdown item styling to any element.
 */
class DropdownItemDirective {
    constructor() {
        // All items need this class
        this._defaultClass = true;
    }
}
DropdownItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownItemDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
DropdownItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: DropdownItemDirective, selector: "[psUiDropdownItem], ps-ui-dropdown-item", host: { properties: { "class.dropdown-item": "this._defaultClass" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[psUiDropdownItem], ps-ui-dropdown-item',
                }]
        }], propDecorators: { _defaultClass: [{
                type: HostBinding,
                args: ['class.dropdown-item']
            }] } });

class DropdownModule {
}
DropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownModule, declarations: [DropdownComponent,
        DropdownToggleDirective,
        DropdownItemDirective], imports: [CommonModule], exports: [DropdownComponent, DropdownToggleDirective, DropdownItemDirective] });
DropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DropdownComponent,
                        DropdownToggleDirective,
                        DropdownItemDirective,
                    ],
                    exports: [DropdownComponent, DropdownToggleDirective, DropdownItemDirective],
                    imports: [CommonModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DropdownComponent, DropdownItemDirective, DropdownModule, DropdownToggleDirective };
